module.exports = __webpack_public_path__ + "static/media/itau-unibanco@2x.95ebf25d.jpg";